<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Job'"
      [canGoBack]="true"
      [customBack]="jobBackPage"
      [showDropdownMenu]="true"
      [dropdownMenu]="jobDropdownMenu" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />
<ng-template #content>
  <tidy-wrapper>

    @if (isHKReportedClientCancelation) {
      <tidy-alert class="black-background">
        <tidy-row class="vertical-align-center">
          <tidy-text
            [header]="'You Cancelled'"/>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="booking?.booking?.current_job?.homekeepers?.[0]?.first_name + (' reported that you cancelled the job. ' | translate)" />
          <tidy-text
            [body]="'If you believe '" />
          <tidy-text
            [body]="booking?.booking?.current_job?.homekeepers?.[0]?.first_name"
            [translate]="false" />
          <tidy-text
            [body]="' was the one who cancelled, please '" />
          <tidy-text
            (action)="reportNoShow(booking?.booking?.current_job?.homekeepers?.[0]?.first_name, jobId, booking?.booking?.current_job?.homekeepers?.[0]?.id)"
            [body]="'click here'"
            class="white-link" />
          <tidy-text
            [body]="'.'"/>
        </tidy-row>
        <div style="display: flex; gap: 8px; justify-content: flex-end;">
          <tidy-button
            [text]="'Confirm Cancellation'"
            [action]="boundCancelJob"
            class="secondary" />
          <tidy-button
            [text]="'Book New Time'"
            [action]="boundRescheduleJob"
            class="primary" />
        </div>
      </tidy-alert>
    }

    @if (pendingDispute) {
      <tidy-card>
        <tidy-card-button (action)="goToDisputeResolution()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/yellow-alert.svg'"
              class="header-size" />
            <tidy-text
              [header]="pendingDisputeTitle" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="pendingDisputeBody" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }

    @if (isCantAccessHome) {
      <tidy-alert class="black-background">
        <tidy-row class="vertical-align-center">
          <tidy-text
            [header]="'Trouble Accessing Property'"/>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="booking?.booking?.current_job?.homekeepers?.[0]?.first_name + (' is having trouble accessing your property.  Please reach out to help.' | translate)" />
        </tidy-row>
        <div style="display: flex; gap: 8px; justify-content: flex-end;">
          <tidy-button
            [text]="'Call Pro'"
            [action]="boundCallPro"
            class="primary" />
        </div>
      </tidy-alert>
    }

    @if (isConfirmedCantAccessHome) {
      <tidy-alert class="black-background">
        <tidy-row class="vertical-align-center">
          <tidy-text
            [header]="'Pro Could Not Access Property'"/>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="booking?.booking?.current_job?.homekeepers?.[0]?.first_name + (' confirmed they could not access your property.' | translate)" />
        </tidy-row>
        <div style="display: flex; gap: 8px; justify-content: flex-end;">
          <tidy-button
            [text]="'Cancel Job'"
            [action]="boundCancelJob"
            class="secondary" />
          <tidy-button
            [text]="'Reschedule Job'"
            [action]="boundRescheduleJob"
            class="primary" />
        </div>
      </tidy-alert>
    }

    <tidy-card>
      @if (booking?.service_type_details?.service_category) {
        <div style="display: flex; align-items: flex-start;">
          <tidy-image
            [src]="booking?.service_type_details?.service_category?.icon_url"
            style="width:30px;" />
          <div style="display: flex; flex-direction: column; margin-left: 10px;">
            <tidy-row>
              <tidy-text
                [header]="booking?.service_type_details?.name | titlecase" />
            </tidy-row>
            @if (!booking?.job_request_status) {
              <tidy-row>
                <tidy-text
                  [body]="(booking?.booking?.current_job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (booking?.booking?.current_job?.start_datetime_local | parseDateTime: 'MMM d')" />
                <tidy-text
                  [body]="' at '" />
                <tidy-text
                  [body]="booking?.booking?.current_job?.start_datetime_local | parseDateTime: 'h:mma'" />
                <tidy-small-button
                  [smallIconButton]="true"
                  [image]="'assets/svg/clock-outline.svg'"
                  [matMenuTriggerFor]="timeMenu"
                  style="margin-left: 8px;" />
              </tidy-row>
            } @else {
              @let request = booking?.booking;
              <tidy-row>
                @if (request?.start_date_no_earlier_than === request?.end_date_no_later_than) {
                  <tidy-text
                    [body]="request?.start_date_no_earlier_than | parseDateTime:'ddd MMM d'" />
                  <tidy-text
                    [body]="', start after '" />
                  <tidy-text
                    [body]="request?.start_time_no_earlier_than | parseDateTime:'h:mma'" />
                  <tidy-text
                    [body]="', finish by '" />
                  <tidy-text
                    [body]="request?.end_time_no_later_than | parseDateTime:'h:mma'" />
                } @else {
                  <tidy-text
                    [body]="'Start after '" />
                  <tidy-text
                    [body]="(request?.start_date_no_earlier_than | parseDateTime:'ddd MMM d') + ' ' + (request?.start_time_no_earlier_than | parseDateTime:'h:mma')" />
                  <tidy-text
                    [body]="', finish by '" />
                  <tidy-text
                    [body]="(request?.end_date_no_later_than | parseDateTime:'ddd MMM d') + ' ' + (request?.end_time_no_later_than | parseDateTime:'h:mma')" />
                }
              </tidy-row>
            }
            <tidy-row>
              <tidy-text
                [body]="addressName" />
            </tidy-row>
            @for (item of customFields; track item; let last = $last) {
              <tidy-row [ngClass]="last ? 'no-padding' : ''">
                <tidy-text
                  [body]="item?.name + ': ' + item?.value || 'No Value'" />
                <tidy-small-button
                  [smallIconButton]="true"
                  [image]="'assets/svg/create-outline.svg'"
                  (buttonClick)="jobFormPopup.editCustomFieldValue(item)"
                  style="margin-left: 8px;" />
              </tidy-row>
            }
          </div>
        </div>
      } @else {
        <div style="display: flex; align-items: flex-start;">
          <ion-skeleton-text animated style="width: 30px; height: 30px; border-radius: 6px; flex-shrink: 0;" />
          <div style="display: flex; flex-direction: column; margin-left: 10px; width: 100%;">
            <ion-skeleton-text animated style="width: 55%; height: 18px; border-radius: 6px; margin-bottom: 8px;" />
            <ion-skeleton-text animated style="width: 50%; height: 14px; border-radius: 6px; margin-bottom: 8px;" />
            <ion-skeleton-text animated style="width: 35%; height: 14px; border-radius: 6px; margin-bottom: 8px;" />
            <ion-skeleton-text animated style="width: 30%; height: 14px; border-radius: 6px;" />
          </div>
        </div>
      }
      <mat-menu #timeMenu="matMenu">
        <button mat-menu-item (click)="goToEditBackupTimes()">
          Backup Times
          @if (jobBackupTimesLoaded) {
            ({{ jobBackupTimesCount }} {{ jobBackupTimesCount === 1 ? 'time added' : 'times added' }})
          }
        </button>
      </mat-menu>
    </tidy-card>

    <tidy-row [alignLastItemRight]="hasPrivatePro" class="extra-top-margin">
      <tidy-text
        [header]="'Pro'" />
      @if (hasPrivatePro) {
        <tidy-text
          [actionBody]="booking?.assignment_status == 'unassigned' ? 'Assign Pro' : 'Change Pro'"
          class="white-link"
          (action)="jobFormPopup.goToChangePro()" />
      }
    </tidy-row>

    @if (isProsLoaded) {
      @for (item of pros; track item) {
        <tidy-card>
          <tidy-row class="vertical-align-center no-padding" [alignLastItemRight]="!potentialHomekeeper">
            <div style="display: flex; align-items: center;">
                <tidy-initials-icon
                  [fullName]="(item?.pro?.first_name + ' ' + item?.pro?.last_name) || potentialHomekeeper?.name"
                  style="margin-right: 5px;" />
              @if (item?.pro?.id === null && potentialHomekeeper) {
                <tidy-text
                  [header]="potentialHomekeeper?.name"
                  [translate]="false" />
              } @else {
                <tidy-text
                  [header]="item?.pro?.first_name + ' ' + item?.pro?.last_name"
                  [translate]="false" />
              }
            </div>
            @if (!potentialHomekeeper) {
              <div style="position: relative; margin-left: 8px">
                <tidy-small-button
                  [mediumIconButton]="true"
                  [image]="'assets/img/messages.svg'"
                  (buttonClick)="goToMessageThreadPage(item?.pro)" />
                @if (item?.numberOfUnreadMessages > 0) {
                  <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
                    {{item?.numberOfUnreadMessages}}
                  </div>
                }
              </div>
            }
          </tidy-row>
        @if (item.showMarkNoShowTextValue) {
          <tidy-row style="margin-left: 38px">
            <tidy-text
              (action)="markNoShow(item?.pro)"
              [body]="'Click here'"
              class="white-link"/>
            <tidy-text
              [body]="' if '" />
            <tidy-text
              [body]="item?.pro?.first_name"
              [translate]="false"/>
            <tidy-text
              [body]="' is not responding and did not show up.'" />
          </tidy-row>
        }
        @if (!booking?.service_type_details?.name?.includes('2 Pros') && (potentialHomekeeper?.status == 'declined_by_homekeeper' || potentialHomekeeper?.status == 'accepted_by_customer')) {
          <tidy-row style="margin-left: 38px">
            @if (potentialHomekeeper?.status == 'accepted_by_customer') {
              <tidy-text
                [body]="'You accepted a quote from '" />
              <tidy-text
                [body]="potentialHomekeeper?.name || 'Pro'" />
              <tidy-text
                [body]="'. We are confirming with him.'" />
            }
            @if (potentialHomekeeper?.status == 'declined_by_homekeeper') {
              <tidy-text
                [body]="potentialHomekeeper?.name + ' '" />
              <tidy-text
                [body]="'declined the job. '" />
            }
          </tidy-row>
        }
      </tidy-card>
      }
    }

    @if (!isProsLoaded && booking?.assignment_status !== 'unassigned') {
      <tidy-card>
        <tidy-row class="vertical-align-center no-padding">
          <div style="display: flex; align-items: center;">
            <ion-skeleton-text animated style="width: 40px; height: 40px; border-radius: 50%; margin-right: 5px; flex-shrink: 0;" />
            <ion-skeleton-text animated style="width: 140px; height: 16px; border-radius: 6px;" />
          </div>
        </tidy-row>
      </tidy-card>
    }

    @if (booking?.assignment_status == 'unassigned' || booking?.assignment_status == 'partially_unassigned') {
      <tidy-alert [class]="'black-background ' + (isSearchingForPro ? 'agent-border' : 'fail-agent-border')">
        <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
          <tidy-ai-loader class="agent-icon-small" [isStatic]="!isSearchingForPro" />
          <tidy-text
            [header]="('Pro Search Agent ' | translate) + (isSearchingForPro ? ('- Running' | translate) : ('- Complete' | translate))" />
          <img [src]="themeService.themeMode() === 'dark' ? 'assets/svg/settings-outline-white.svg' : 'assets/svg/settings-outline-black.svg'"
               class="pro-search-settings-icon"
               (click)="goToProSearchAgentSettings()" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          @if (!isSearchingForPro) {
            @if (booking?.job_request_status) {
              <tidy-text
                [helper]="'Nothing matched your instant book settings.'" />
            } @else {
              <tidy-text
                [helper]="'Your pro cancelled and nothing matched your instant book settings.'" />
            }
          } @else {
            @if (booking?.job_request_status) {
              <tidy-text
                [helper]="'Searching for a pro during your requested times'" />
            } @else {
              <tidy-text
                [helper]="'Your pro cancelled, searching for a substitute during your backup times'" />
            }
          }
        </tidy-row>
        @if (!booking?.job_request_status && requestedSearchTimes.length) {
          <tidy-row class="no-padding">
            <tidy-text
              [helper]="'Requested Times:'" />
          </tidy-row>
          @for (line of requestedSearchTimes; track line) {
            <tidy-row class="no-padding">
              <tidy-text
                [helper]="line"
                [translate]="false" />
            </tidy-row>
          }
        }
        @if (isSearchingForPro && (booking?.waterfall_notification_history?.[waterfallIndex]?.waterfall_notification_history | hideAssignedProDidNotContact: booking?.booking?.current_job?.homekeepers)?.length > 0) {
          <tidy-notification-history
            [items]="booking?.waterfall_notification_history?.[waterfallIndex]?.waterfall_notification_history"
            [isSearchingForPro]="isSearchingForPro"
            [hasQuotes]="booking?.quotes?.quotes?.length > 0"
            [assignedPros]="booking?.booking?.current_job?.homekeepers"
            (viewProAction)="goToProPage($event)"
            (viewHistoryDetails)="goToNotificationDetailsPage($event)"
            [notificationHistory]="notificationHistory"
            [isLoadingNotificationHistory]="isLoadingNotificationHistory"
            (selectionChange)="checkWaterfallHistory($event)" />
        } @else if (isSearchingForPro) {
          <tidy-row>
            <tidy-text
              [body]="'<i>Check back soon for a notification history and quotes from pros.</i>'" />
          </tidy-row>
        }
        <!-- Quotes Carousel -->
        @if (parsedQuotes.length > 0) {
          <tidy-row class="extra-top-padding vertical-align-center">
            <tidy-ai-image
              [type]="'bid'" />
            <tidy-text
              [header]="'Quotes Found'" class="primary" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="'Compare pros and choose a time that works for you:'" />
          </tidy-row>

          <div class="quotes-carousel">
            @if (showQuotesLeftArrow) {
              <button class="quotes-carousel-arrow quotes-carousel-arrow-left" (click)="scrollQuotesLeft()">
                <span
                  class="quotes-carousel-arrow-icon"
                  [style.-webkit-mask-image]="'url(assets/svg/chevron-back-outline.svg)'"
                  [style.mask-image]="'url(assets/svg/chevron-back-outline.svg)'"></span>
              </button>
            }
            <div class="quotes-carousel-track" #quotesScrollContainer>
              @for (quote of parsedQuotes; track quote.id) {
                <div
                  class="quotes-carousel-card"
                  [class.quotes-carousel-card--selected]="quote.id === selectedQuoteId"
                  (click)="selectQuote(quote.id)">

                  @if (quote.id === selectedQuoteId) {
                    <div class="quotes-carousel-card-arrow"></div>
                  }

                  <div class="quotes-carousel-card-header">
                    @if (quote.profileImageUrl) {
                      <img
                        [src]="quote.profileImageUrl"
                        class="quotes-avatar-img" />
                    } @else {
                      <tidy-initials-icon
                        [fullName]="quote.name"
                        [size]="'large'" />
                    }
                    <div class="quotes-carousel-card-header-info">
                      <tidy-text
                        [body]="quote.name"
                        [translate]="false"
                        class="bold" />
                      @if (quote.singlePrice !== null) {
                        <div class="quotes-carousel-card-price">
                          <span class="quotes-price-amount">{{quote.singlePrice | tcurrency}}</span>
                        </div>
                      }
                    </div>
                  </div>

                  <div class="quotes-carousel-card-body">
                    @if (quote.yearsExperience || quote.teamSize || quote.totalJobsLabel) {
                      <div class="quotes-stat-chips">
                        @if (quote.yearsExperience) {
                          <span class="quotes-stat-chip">
                            <tidy-image
                              [src]="'assets/svg/star-yellow.svg'"
                              class="quotes-stat-chip-icon" />
                            {{quote.yearsExperience}} Yrs Exp
                          </span>
                        }
                        @if (quote.teamSize) {
                          <span class="quotes-stat-chip">
                            <tidy-image
                              [src]="'assets/svg/people-outline.svg'"
                              class="quotes-stat-chip-icon" />
                            Team of {{quote.teamSize}}
                          </span>
                        }
                        @if (quote.totalJobsLabel) {
                          <span class="quotes-stat-chip">
                            <tidy-image
                              [src]="'assets/svg/briefcase-outline.svg'"
                              class="quotes-stat-chip-icon" />
                            {{quote.totalJobsLabel}}
                          </span>
                        }
                      </div>
                    }

                    @if (quote.pitchDescription) {
                      <div class="quotes-carousel-card-bio">
                        {{quote.pitchDescription}}
                      </div>
                    }

                    @if (quote.isVrhp) {
                      <div class="quotes-vrhp-badge">
                        <span
                          class="quotes-vrhp-badge-icon"
                          [style.-webkit-mask-image]="'url(assets/svg/shield-checkmark-outline.svg)'"
                          [style.mask-image]="'url(assets/svg/shield-checkmark-outline.svg)'"></span>
                        VRHP Verified Professional
                      </div>
                    }

                    @if (quote.certifications?.length > 0) {
                      <div class="quotes-carousel-card-trust">
                        <div class="quotes-cert-chips">
                          @for (cert of quote.certifications.slice(0, 2); track cert.type) {
                            <span class="quotes-cert-chip">
                              <span
                                class="quotes-cert-check-icon"
                                [style.-webkit-mask-image]="'url(assets/svg/checkmark-circle-outline.svg)'"
                                [style.mask-image]="'url(assets/svg/checkmark-circle-outline.svg)'"></span>
                              {{cert.label}}
                            </span>
                          }
                          @if (quote.certifications.length > 2) {
                            <span class="quotes-cert-more">+{{quote.certifications.length - 2}} more certs</span>
                          }
                        </div>
                      </div>
                    }

                    <!-- Link icons hidden for now
                    @if (quote.links?.length > 0) {
                      <div class="quotes-cert-chips">
                        @for (link of quote.links; track link.type) {
                          <span class="quotes-cert-icon-chip">
                            <tidy-image
                              [src]="getCredentialIcon(link.type)"
                              class="quotes-cert-icon-only no-right-margin" />
                          </span>
                        }
                      </div>
                    }
                    -->
                  </div>

                </div>
              }
            </div>
            @if (showQuotesRightArrow) {
              <button class="quotes-carousel-arrow quotes-carousel-arrow-right" (click)="scrollQuotesRight()">
                <span
                  class="quotes-carousel-arrow-icon"
                  [style.-webkit-mask-image]="'url(assets/svg/chevron-forward-outline.svg)'"
                  [style.mask-image]="'url(assets/svg/chevron-forward-outline.svg)'"></span>
              </button>
            }
          </div>

          <!-- Selected Quote Detail Panel -->
          @if (selectedQuote) {
            <div class="quotes-detail-panel">
              <div class="quotes-detail-header">
                <div class="quotes-detail-header-text">
                  <tidy-text
                    [header]="'Book ' + selectedQuote.name"
                    [translate]="false" />
                  <tidy-text
                    [helper]="'Select an available time to book'" />
                </div>
                @if (selectedQuote.singlePrice !== null) {
                  <span class="quotes-detail-price">{{selectedQuote.singlePrice | tcurrency}}</span>
                }
              </div>

              <div class="quotes-detail-body">
                @if (selectedQuote.pitchDescription || selectedQuote.certifications?.length > 0 || selectedQuote.links?.length > 0) {
                  <div class="quotes-detail-left">
                    @if (selectedQuote.pitchDescription) {
                      <div class="quotes-detail-section-header">
                        <span
                          class="quotes-detail-section-icon"
                          [style.-webkit-mask-image]="'url(assets/svg/information-circle-outline.svg)'"
                          [style.mask-image]="'url(assets/svg/information-circle-outline.svg)'"></span>
                        <tidy-text
                          [body]="'About the Provider'"
                          class="bold" />
                      </div>
                      <p class="quotes-detail-bio">
                        {{selectedQuote.pitchDescription}}
                      </p>
                    }

                    @if (selectedQuote.certifications?.length > 0) {
                      <div class="quotes-detail-section-header">
                        <span
                          class="quotes-detail-section-icon"
                          [style.-webkit-mask-image]="'url(assets/svg/ribbon-outline.svg)'"
                          [style.mask-image]="'url(assets/svg/ribbon-outline.svg)'"></span>
                        <tidy-text
                          [body]="'Verified Credentials'"
                          class="bold" />
                      </div>
                      <div class="quotes-detail-creds">
                        @for (cert of selectedQuote.certifications; track cert.type) {
                          <div class="quotes-detail-cred-item">
                            <span
                              class="quotes-cert-check-icon"
                              [style.-webkit-mask-image]="'url(assets/svg/checkmark-circle-outline.svg)'"
                              [style.mask-image]="'url(assets/svg/checkmark-circle-outline.svg)'"></span>
                            <span>{{cert.label}}</span>
                          </div>
                        }
                      </div>
                    }

                    @if (selectedQuote.links?.length > 0) {
                      <div class="quotes-detail-section-header">
                        <span
                          class="quotes-detail-section-icon"
                          [style.-webkit-mask-image]="'url(assets/svg/link-outline.svg)'"
                          [style.mask-image]="'url(assets/svg/link-outline.svg)'"></span>
                        <tidy-text
                          [body]="'Links'"
                          class="bold" />
                      </div>
                      <div class="quotes-detail-creds">
                        @for (link of selectedQuote.links; track link.type) {
                          <div class="quotes-detail-cred-item">
                            <tidy-image
                              [src]="getCredentialIcon(link.type)"
                              class="quotes-link-icon no-right-margin" />
                            <tidy-text
                              [body]="link.label"
                              (action)="openCredentialLink(link.text_value)"
                              class="white-link" />
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                <div class="quotes-detail-right">
                  @if (selectedQuote.dates?.length === 0) {
                    <div class="quotes-no-times">
                      <tidy-text
                        [helper]="'No available times listed.'" />
                    </div>
                  } @else {
                    <div class="quotes-detail-section-header">
                      <span
                        class="quotes-detail-section-icon"
                        [style.-webkit-mask-image]="'url(assets/svg/time-outline.svg)'"
                        [style.mask-image]="'url(assets/svg/time-outline.svg)'"></span>
                      <tidy-text
                        [body]="'Select a Time'"
                        class="bold" />
                    </div>
                    @for (dateGroup of selectedQuote.dates; track dateGroup.date) {
                      <tidy-text
                        [body]="dateGroup.date | parseDateTime:'dddd MMM d':''"
                        class="bold" />
                      <div class="quotes-detail-times">
                        @for (time of dateGroup.times; track time.time) {
                          <tidy-pill-button
                            [text]="time.viewValue"
                            (buttonClick)="onQuoteTimeSelected(selectedQuote, dateGroup.date, time)" />
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
        }

        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 10px;">
          @if (booking?.assignment_status == 'partially_unassigned') {
            <tidy-button
            [text]="'Keep One Pro'"
            [action]="boundKeepOnePro.bind(this)"
            class="secondary"
            [smallText]="true" />
          }
          <tidy-button
            [text]="'Update Requested Times'"
            [action]="boundUpdateRequestedTimes.bind(this)"
            class="secondary"
            [smallText]="true" />
        </div>
      </tidy-alert>
    }
    @for (cancellation of cancellationReasons; track cancellation.firstName) {
      <tidy-alert class="black-background">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/alert-circle-outline-grey.svg'"
            style="width: 16px; height: 16px; margin-right: 5px;" />
          <tidy-text
            [helper]="cancellation.firstName + (' had to cancel because ' | translate) + cancellation.reason" />
        </tidy-row>
      </tidy-alert>
    } 
    @if ((booking?.waterfall_notification_history?.[waterfallIndex]?.waterfall_notification_history | hideAssignedProDidNotContact: booking?.booking?.current_job?.homekeepers)?.length > 0) {
      @if (!showProSearchAgentHistory) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'View Pro Search Agent History'"
            class="white-link"
            (action)="toggleShowProSearchAgentHistory()" />
        </tidy-row>
      }
      @if (showProSearchAgentHistory) {
        <tidy-alert class="black-background">
          <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
            <tidy-ai-loader class="agent-icon-small" [isStatic]="true" />
            <tidy-text
              [header]="'Pro Search Agent History'" />
            <tidy-text
              [body]="'Hide History'"
              class="white-link"
              (action)="toggleShowProSearchAgentHistory()" />
          </tidy-row>
          <tidy-notification-history
            [items]="booking?.waterfall_notification_history?.[waterfallIndex]?.waterfall_notification_history"
            [isSearchingForPro]="isSearchingForPro"
            [hasQuotes]="booking?.quotes?.quotes?.length > 0"
            [assignedPros]="booking?.booking?.current_job?.homekeepers"
            (viewProAction)="goToProPage($event)"
            (viewHistoryDetails)="goToNotificationDetailsPage($event)"
            [notificationHistory]="notificationHistory"
            [isLoadingNotificationHistory]="isLoadingNotificationHistory"
            (selectionChange)="checkWaterfallHistory($event)" />
        </tidy-alert>
      }
    }

    <tidy-row class="extra-top-margin">
      <tidy-text
        [header]="'Job Instructions'" />
    </tidy-row>

    @if (!isInstructionsLoaded) {
      <tidy-card>
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <ion-skeleton-text animated style="width: 20px; height: 20px; border-radius: 6px; margin-right: 8px; flex-shrink: 0;" />
          <ion-skeleton-text animated style="width: 40%; height: 14px; border-radius: 6px;" />
        </tidy-row>
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <ion-skeleton-text animated style="width: 20px; height: 20px; border-radius: 6px; margin-right: 8px; flex-shrink: 0;" />
          <ion-skeleton-text animated style="width: 30%; height: 14px; border-radius: 6px;" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <ion-skeleton-text animated style="width: 20px; height: 20px; border-radius: 6px; margin-right: 8px; flex-shrink: 0;" />
          <ion-skeleton-text animated style="width: 65%; height: 14px; border-radius: 6px;" />
        </tidy-row>
      </tidy-card>
    }

    @if (isInstructionsLoaded) {
      <tidy-card>
        @if (!booking?.booking?.task_list?.id && !(booking?.booking_notes?.length > 0 || bookingFormAnswers?.length > 0) && !(tasksService.tasksLoaded && tasksService.linkedTasks.length > 0)) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [helper]="'No instructions'" />
        </tidy-row>
      }
      @if (booking?.booking?.task_list?.id) {
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <div style="flex: 1; display: flex; flex-wrap: wrap; align-items: center;">
            <tidy-image
              [src]="'assets/img/survey.svg'"
              class="header-size" />
            <tidy-text
              [body]="booking?.booking?.task_list?.title" />
          </div>
          <tidy-small-button
            [smallIconButton]="true"
            [image]="'assets/svg/create-outline.svg'"
            (buttonClick)="jobFormPopup.openChecklistPopup()"
            style="margin-left: 8px;" />
        </tidy-row>
      }
      @if (booking?.booking_notes?.length > 0) {
        <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
          <div class="vertical-align-middle" style="flex: 1;">
            @for (note of booking?.booking_notes; track note) {
              @if (note?.type == 'text') {
                <tidy-image
                  [src]="'assets/img/information.svg'"
                  class="header-size"
                  style="margin-right: 5px;" />
                <tidy-text
                  [body]="note?.text" />
              }
            }
          </div>
          <tidy-small-button
            [smallIconButton]="true"
            [image]="'assets/svg/create-outline.svg'"
            (buttonClick)="jobFormPopup.openNotePopup()"
            style="margin-left: 8px;" />
        </tidy-row>
      }
      @if (bookingFormAnswers?.length > 0) {
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/img/information.svg'"
            class="header-size" />
          <tidy-text
            [body]="'More Detail'" />
        </tidy-row>
        @for (answer of bookingFormAnswers; track answer) {
          @if (answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area') {
            <tidy-row>
              <tidy-text
                [body]="answer?.template_input?.label + ': ' + answer?.data?.value" />
            </tidy-row>
            @if (answer?.template_input?.image_url) {
              <tidy-photo-note
                [src]="answer?.template_input?.image_url" />
            }
          }
          @if (answer?.template_input?.type == 'select') {
            <tidy-row>
              <tidy-text
                [body]="answer?.template_input?.label + ': ' + answer.selectValue" />
            </tidy-row>
            @if (answer?.template_input?.image_url) {
              <tidy-photo-note
                [src]="answer?.template_input?.image_url" />
            }
          }
          @if (answer?.template_input?.type == 'multiselect') {
            <tidy-row>
              <tidy-text
                [body]="answer?.template_input?.label + ': ' + answer.multiselectValue" />
            </tidy-row>
            @if (answer?.template_input?.image_url) {
              <tidy-photo-note
                [src]="answer?.template_input?.image_url" />
            }
          }
          @if (answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image') {
            <tidy-row>
              <tidy-text
                [body]="answer?.template_input?.label" />
            </tidy-row>
            <tidy-carrousel
              class="photo-notes-carrousel only-padding-bottom"
              [scaleImages]="true">
              <tidy-photo-note
                *tidyCarrousel
                [src]="answer?.data?.value" />
            </tidy-carrousel>
          }
          @if (answer?.template_input?.type == 'files' && answer?.template_input?.data?.type == 'images') {
            <tidy-row>
              <tidy-text
                [body]="answer?.template_input?.label" />
            </tidy-row>
            <tidy-carrousel
              class="photo-notes-carrousel only-padding-bottom"
              [scaleImages]="true">
              @for (imageUrl of answer?.data?.value; track imageUrl) {
                <tidy-photo-note
                  *tidyCarrousel
                  [src]="imageUrl" />
              }
            </tidy-carrousel>
          }
        }
        @if (!(tasksService.tasksLoaded && tasksService.linkedTasks.length > 0) && (!booking?.booking?.task_list?.id || !(booking?.booking_notes?.length > 0 || bookingFormAnswers?.length > 0) || (addressId && !(tasksService.tasksLoaded && tasksService.linkedTasks.length > 0)))) {
          <div style="margin-bottom: 15px"></div>
        }
      }
      @if (tasksService.tasksLoaded && tasksService.linkedTasks.length > 0) {
          <tidy-row class="vertical-align-center" [ngClass]="(!booking?.booking?.task_list?.id || !(booking?.booking_notes?.length > 0 || bookingFormAnswers?.length > 0) || (addressId && !(tasksService.tasksLoaded && tasksService.linkedTasks.length > 0))) ? 'extra-bottom-padding' : ''">
            <div style="flex: 1; display: flex; flex-wrap: wrap; align-items: center;">
              <tidy-image
                [src]="'assets/img/maintenance.svg'"
                class="header-size" />
              <ng-container class="vertical-align-middle">
                @for (task of tasksService.linkedTasks; track task; let last = $last) {
                  <tidy-text
                    [body]="task.title"
                    (action)="tasksService.goToTask(task.id)"
                    class="white-link" />
                  @if (!last) {
                    <span>, &nbsp;</span>
                  }
                }
              </ng-container>
            </div>
            <tidy-small-button
              [smallIconButton]="true"
              [image]="'assets/svg/create-outline.svg'"
              (buttonClick)="openMaintenanceDropdown()"
              style="margin-left: 8px;" />
          </tidy-row>
      }
      @if (!booking?.booking?.task_list?.id || !(booking?.booking_notes?.length > 0 || bookingFormAnswers?.length > 0) || (addressId && !(tasksService.tasksLoaded && tasksService.linkedTasks.length > 0))) {
        <div class="section-add-buttons">
          @if (!booking?.booking?.task_list?.id) {
            <tidy-pill-button
              [image]="'assets/svg/checkbox-outline.svg'"
              [text]="'Add Checklist'"
              (buttonClick)="jobFormPopup.openChecklistPopup()" />
          }
          @if (!booking?.booking_notes?.length > 0) {
            <tidy-pill-button
              [image]="'assets/svg/create-outline.svg'"
              [text]="'Add Note'"
              (buttonClick)="jobFormPopup.openNotePopup()" />
          }
          @if (addressId && !(tasksService.tasksLoaded && tasksService.linkedTasks.length > 0)) {
            <tidy-pill-button
              [image]="'assets/svg/construct-outline.svg'"
              [text]="'Add Maintenance'"
              (buttonClick)="openMaintenanceDropdown()" />
          }
        </div>
      }
      @if (addressId) {
        <tidy-task-dropdown
          #maintenanceDropdown
          [showTrigger]="false"
          [priorPage]="'job'"
          [priorPageParams]="{booking: booking, addressName: addressName, settings: settings, clientName: clientName}"
          [bookingId]="booking?.booking?.id"
          [addressId]="addressId"
          [jobId]="jobId" />
        }
      </tidy-card>
    }

    <!-- Restocking tasks: orders the customer attached to this job so the pro
         restocks them (card gCUZuCjf). One section per attached order, plus a
         picker for the address's assignable (ordered/delivered) orders. -->
    @if (booking && (restockTasks?.length > 0 || assignableOrderOptions?.length > 0)) {
      <tidy-row class="vertical-align-center extra-top-padding">
        <tidy-image
          [src]="'assets/svg/cube-outline.svg'"
          class="header-size" />
        <tidy-text
          [header]="'Restocking'" />
      </tidy-row>
      @if (restockTasks?.length > 0) {
        <restock-tasks-display
          [tasks]="restockTasks"
          [editable]="true"
          [saveNoteAction]="boundSaveRestockNote"
          (unassignOrder)="unassignRestockOrder($event)" />
      }
      @if (assignableOrderOptions?.length > 0) {
        @if (!showRestockPicker) {
          <div class="section-add-buttons">
            <tidy-pill-button
              [image]="'assets/svg/cube-outline.svg'"
              [text]="'Add Restocking Task'"
              (buttonClick)="openRestockPicker()" />
          </div>
        } @else {
          <tidy-card class="restock-picker-card">
            <tidy-row
              [alignLastItemRight]="true"
              class="vertical-align-center extra-bottom-padding">
              <tidy-text
                [body]="'Attach a restock order'"
                class="bold" />
              <tidy-text
                [actionBody]="'Cancel'"
                (action)="closeRestockPicker()"
                class="link" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [helper]="'The pro will restock it at this job.'" />
            </tidy-row>
            @for (option of assignableOrderOptions; track option.id) {
              <tidy-card-button (action)="assignRestockOrder(option.id)">
                <div class="restock-picker-option">
                  <div class="restock-picker-thumb">
                    <tidy-image
                      [src]="'assets/svg/cube-outline.svg'"
                      class="restock-picker-thumb-icon" />
                  </div>
                  <div class="restock-picker-option-main">
                    <tidy-text
                      [body]="option.title"
                      [translate]="false"
                      class="bold" />
                    <tidy-text
                      [helper]="option.subtitle"
                      [translate]="false" />
                  </div>
                  <span [class]="'restock-status-chip ' + option.statusClass">{{ option.statusLabel | translate }}</span>
                </div>
              </tidy-card-button>
            }
          </tidy-card>
        }
      }
    }

    @if (booking && !hasCurrentIssue) {
      <tidy-ongoing-checklist
        [booking]="booking"
        [jobId]="jobId"
        [addressId]="addressId"
        [isNativeMobile]="isNativeMobile" />
    }

    @if (!isMapLoaded && booking) {
      <tidy-row>
        <ion-skeleton-text
          animated
          style="width: 100%; height: 300px; border-radius: 6px;" />
      </tidy-row>
    }


    <tidy-card [style]="!mapInstance ? 'padding: 0px; display: none; margin-top: 20px;' : 'padding: 0px; margin-top: 15px;'">
      <div [attr.id]="'map' + jobId" #map style="width: 100%; height: 300px">
      </div>
    </tidy-card>


    @for (event of jobEvents; track event) {
      @if (event?.event?.name === 'samantha_service.booking.created') {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="event?.text + (' on ' | translate) + (event?.happened_at | parseDateTime:'MMM d':'local') + (' at ' | translate) + (event?.happened_at | parseDateTime:'h:mma':'local')" />
        </tidy-row>
      }
    }

    <tidy-job-form-popup
      #jobFormPopup
      [bookingId]="bookingId"
      [jobId]="jobId"
      [booking]="booking"
      [addressId]="addressId"
      [checklistItems]="checklistItems"
      [customFields]="customFields"
      (noteSaved)="onPopupNoteSaved($event)"
      (checklistSaved)="onPopupChecklistSaved($event)"
      (customFieldSaved)="onPopupCustomFieldSaved($event)"
      (proChanged)="onPopupProChanged($event)" />


  </tidy-wrapper>
</ng-template>

<ng-template #loadErrorContent>
  <tidy-wrapper>
    <tidy-alert>
      <tidy-row>
        <tidy-text
          [body]="loadErrorMessage" />
      </tidy-row>
    </tidy-alert>
  </tidy-wrapper>
</ng-template>


@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="loadErrorMessage ? loadErrorContent : content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="loadErrorMessage ? loadErrorContent : content" />
  </ion-content>
}
